import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import {
  getStudyList,
  setSelectedStudy,
  updateModuleStudy,
} from '../../actions/rldToolActions';
import CommonStudySelector from '../common/CommonStudySelector';
import { CROSSTAB_FEATUREID, RLD_TOOL } from '../../constants';
const RldStudySelector = props => {
  const dispatch = useDispatch();
  //initialize the variables from redux
  const { studies, selectedStudy } = useSelector(
    ({ rldTool }) => rldTool.study
  );
  const { selectedAccount } = useSelector(state => state.rldTool.account);

  const [selectedWeightType, setSelectedWeightType] = useState(
    selectedStudy && selectedStudy.cw ? selectedStudy.cw[0] : {}
  );
  const [hideWeight, setHideWeight] = useState(true);
  //get fetch studies data
  useEffect(() => {
    if (!isEmpty(selectedAccount)) {
      setHideWeight(true);
      setSelectedWeightType({});
      dispatch(getStudyList(props.uid, selectedAccount.accountId));
    }
  }, [selectedAccount]);

  useEffect(() => {
    if (!isEmpty(selectedStudy)) {
      if (isEmpty(selectedWeightType)) {
        setSelectedWeightType(
          selectedStudy && selectedStudy.cw ? selectedStudy.cw[0] : {}
        );
      }
      setHideWeight(false);
    }
  }, [selectedStudy]);

  const handleStudySelected = (e, weightType) => {
    const updatedStudyItem = {
      ...selectedStudy,
      wt: weightType.wt,
      dv: weightType.dv ? weightType.dv : 1000,
    };
    dispatch(updateModuleStudy(RLD_TOOL, updatedStudyItem));
    setSelectedWeightType(weightType);
    dispatch(setSelectedStudy(e));
  };

  const handleChangeWeightType = weightType => {
    const updatedStudyItem = {
      ...selectedStudy,
      wt: weightType.wt,
      dv: weightType.dv ? weightType.dv : 1000,
    };
    dispatch(updateModuleStudy(RLD_TOOL, updatedStudyItem));
    setSelectedWeightType(weightType);
  };

  return (
    <div>
      <CommonStudySelector
        studies={studies}
        featureID={CROSSTAB_FEATUREID}
        defaultStudy={selectedStudy}
        setMethod={handleStudySelected}
        showWeightType
        handleChangeWeightType={handleChangeWeightType}
        selectedWeightType={selectedWeightType}
        menuName={RLD_TOOL}
        hideWeightType={hideWeight}
      />
    </div>
  );
};

export default RldStudySelector;
